import PocketBase from 'pocketbase';

const pbUrl = process.env.REACT_APP_PB_URL;
const pb = new PocketBase(pbUrl);

// Évite l’annulation automatique des requêtes en cas de nouvelle requête
pb.autoCancellation(false);

export default pb;
